/**
 * All available types of SVGs present in the eon-ui-icons repository.
 */
export enum SvgType {
  ICON = "icon",
  PICTOGRAM = "pictogram"
}
